
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes jQuery, UIkit and other libraries.
 */
import Vue from 'vue';
// SUP-346 — outerweb no longer installs the legacy `gwbui/src/components/form`
// (which registers GwbForm/vuelidate 0.7 and GwbFormInput together). It still needs
// GwbFormInput directly (Select and Icons depend on it, see below), so that's
// registered on its own, and GwbFormV2 replaces the legacy form's install.
import FormInput from 'gwbui/src/components/form/FormInput.vue';
import GwbFormV2 from 'gwbui/src/components/form-v2';
// Import ONLY the ui-kit modules outerweb actually renders — NOT the full
// registry. With extractStyles:false every registered component's global CSS
// is injected at app.js-execution time, and the kit's button.scss redefines
// .c-button (font:inherit; padding:1rem; transition:all 280ms) — restyling
// the server-rendered conversion-page buttons ~1 frame AFTER first paint,
// which users saw as buttons easing large→small on every load. Select is
// used by sign-up templates; Icons is required by FormInput's <gwb-icon>;
// Popover backs <gwb-select>'s dropdown — Select.vue renders <gwb-popover>,
// so without it the option list has no absolute-positioned, v-if-gated
// overlay and renders permanently inline in document flow, pushing page
// content (and the Continue button) down. GWB-494 trimmed the full gwbui
// registry to fix the button flash and dropped this dependency.
import GwbVueUISelect from 'gwbui/src/components/select';
import GwbVueUIIcons from 'gwbui/src/components/icons';
import GwbVueUIPopover from 'gwbui/src/components/popover';
import CoverBgImage from './modules/cover-bg-image';
import CategoryBalloons from './modules/category-balloons';
import AlpineModules from './modules/alpine';

import GuestApplyForm from './components/guest-apply-form.vue';
import SignUpForm from './components/sign-up-form.vue';
import LoginForm from './components/login-form.vue';
import PasswordResetForm from './components/password-reset-form.vue';
import Faq from './components/faq.vue';
import Quiz from './components/quiz.vue';

require('./sentry');
require('./mixpanel');
require('./bootstrap');

/**
 * Axios HTTP library available as global and Vue $http service
 */

window.axios = Vue.prototype.$http = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    'X-Requested-With': 'XMLHttpRequest', // So Laravel recognises ajax request
    Accept: 'application/json',
};


Vue.component(FormInput.name, FormInput);
Vue.use(GwbFormV2);
Vue.use(GwbVueUISelect);
Vue.use(GwbVueUIIcons);
Vue.use(GwbVueUIPopover);
CoverBgImage.init();
CategoryBalloons.init();
AlpineModules.init();

/**
 * andywer/laravel-js-localization javascript trans() function in Vue.js template context.
 */
Vue.prototype.$lang = (value, replacements) => window.trans(value, replacements);

Vue.prototype.$getURLParameter = function getURLParameter(name) {
    return decodeURIComponent((new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ''])[1].replace(/\+/g, '%20')) || null;
};

if (document.getElementById('outerweb-app')) {
    new Vue({
        el: '#outerweb-app',
        components: {
            GuestApplyForm,
            SignUpForm,
            LoginForm,
            PasswordResetForm,
            Faq,
            Quiz,
        },
    });
}

// Init Foundation framework components
$(document).foundation();
